import React, { useState } from "react";
import API from "../../api/axiosConfig";
import { FaPaperclip, FaCamera, FaMicrophone } from "react-icons/fa";
import Swal from "sweetalert2";

const Reporte = () => {
  const [descripcion, setDescripcion] = useState("");
  const [area, setArea] = useState("");
  const [imagen, setImagen] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // 📸 Seleccionar archivo
  const handleImage = (e) => {
    const file = e.target.files[0];
    setImagen(file);
    setPreview(URL.createObjectURL(file));
  };

  // 🎤 Voz
  const usarVoz = () => {
    if (!("webkitSpeechRecognition" in window)) {
      alert("Tu navegador no soporta voz");
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "es-ES";

    recognition.onresult = (event) => {
      setDescripcion(event.results[0][0].transcript);
    };

    recognition.start();
  };

  // 🚀 Enviar
  const enviar = async () => {
    if (!descripcion || !area) {
      alert("Completa área y descripción");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("descripcion", descripcion);
      formData.append("area", area);

      if (imagen) {
        formData.append("imagen", imagen);
      }

      await API.post("/tickets", formData);

      Swal.fire({
        icon: "success",
        title: "Incidencia enviada",
        text: "Tu incidencia fue reportada correctamente",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#2563eb"
      }).then(() => {
        window.location.reload(); // 🔥 refresca
      });

    } catch (error) {
      console.error("ERROR REAL:", error);
      alert(error.response?.data?.message || "Error al enviar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white pb-32">

      {/* HEADER */}
      <div className="p-4">
        <div className="flex justify-center items-center py-1 bg-white rounded-xl mb-4">

          <div className="flex items-center gap-3">

            {/* LOGO */}
            <img
              src="/logo.png"
              alt="SPTIKE"
              className="w-16 h-16 object-contain"
            />

            {/* TEXTO */}
            <div>
              <h1 className="text-4xl font-black text-black leading-tight">
                SPTIKE
              </h1>
              <p className="text-gray-600 text-sm -mt-1">
                Soporte de incidencias
              </p>
            </div>

          </div>

        </div>

        {/* AREA */}
        <select
          className="w-full p-3 rounded-xl bg-gray-800 border border-gray-700"
          value={area}
          onChange={(e) => setArea(e.target.value)}
        >
          <option value="">Seleccionar área</option>
          <option value="Sistemas">💻 Sistemas</option>
          <option value="Mantenimiento">🛠 Mantenimiento</option>
          <option value="Red">🌐 Red</option>
        </select>
      </div>

      {/* PREVIEW */}
      {preview && (
        <div className="px-4 mb-4">
          <img
            src={preview}
            alt=""
            className="w-full h-48 object-cover rounded-xl border border-gray-700"
          />
        </div>
      )}

      {/* INPUT CHAT */}
      <div className="fixed bottom-0 left-0 w-full bg-gray-900 p-3 border-t border-gray-700">

        <div className="flex items-center gap-2 bg-gray-800 rounded-full px-3 py-2">

          {/* 📎 ADJUNTAR */}
          <label className="cursor-pointer text-gray-400 text-lg">
            <FaPaperclip />
            <input
              type="file"
              accept="image/*"
              onChange={handleImage}
              hidden
            />
          </label>

          {/* 📸 CÁMARA */}
          <label className="cursor-pointer text-gray-400 text-lg">
            <FaCamera />
            <input
              type="file"
              accept="image/*"
              capture="environment"
              onChange={handleImage}
              hidden
            />
          </label>

          {/* INPUT TEXTO */}
          <input
            type="text"
            placeholder="Mensaje..."
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            className="flex-1 bg-transparent text-white outline-none px-2"
          />

          {/* 🎤 MICRÓFONO */}
          <button
            onClick={usarVoz}
            className="bg-green-500 p-3 rounded-full text-white shadow-md"
          >
            <FaMicrophone />
          </button>

        </div>

        {/* BOTÓN ENVIAR */}
        <button
          onClick={enviar}
          disabled={loading}
          className="mt-2 w-full bg-blue-600 hover:bg-blue-700 py-3 rounded-full font-semibold transition"
        >
          {loading ? "Enviando..." : "Enviar"}
        </button>

      </div>

    </div>
  );
};

export default Reporte;